import { IHomeworkDataDB } from './types';

type TReview = {
  homeworkId: string
  review: IHomeworkDataDB['review']
}

const review11: TReview = {
  homeworkId: 'how-to-draw-free_HowToDrawSimilarPictureLine_t6qrnq_Practice_iqln35_hw-FhEwHm2rg4dqGzqMjiRhfFhgEIk1',
  review: [
    { type: 'text', text: 'Вы очень здорово порисовали на этой неделе! Много экспериментов с разными линиями, фактурами, ограничениями на рисунок.' },
    { type: 'text', text: '"Нет ничего лучше того варианта, что получился в итоге" — очень здоровый, рабочий подход.' },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно залогиниться под любой почтой.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/M8SeWVu0YzLQgbX44Z8zMc/%D0%A1%D0%B2%D0%B5%D1%82%D0%BB%D0%B0%D0%BD%D0%B0-%D0%91%D0%BB%D0%BE%D0%BA?type=design&node-id=0%3A1&mode=design&t=k8bLivLrhG0qyev1-1' },
        },
      ]}

  ],
};

const review12: TReview = {
  homeworkId: 'how-to-draw-free_HowToDrawSimilarPictureLine_t6qrnq_Practice_iqln35_hw-h3MpdAbMR0bd3Vx1r4S5OX5kxeE3',
  review: [
    { type: 'text', text: 'Добрый день! Не уметь рисовать — нормально. Я не умею рисовать портреты. И это понятно, у меня мало опыта, вот я и не умею. Приятная новость в том что, чтобы рисовать портреты, не надо "уметь рисовать". Надо брать и рисовать.' },
    { type: 'text', text: 'Вы большая молодец! На этой неделе у вас получилось сделать 14 рисунков, которыми вы захотели поделиться с другими! Это в бесконечное количество раз лучше, чем не нарисовать ничего.' },
    { type: 'text', text: '"Но, дальше теории стало для меня много, это моя постоянная проблема, устать от теории до рисования." – много теории, не читайте теорию. Открывайте сразу страницу с заданием и делайте задание. Если в процессе поймете, что чего-то не хватает, точечно открывайте теорию. Или вообще забудьте про теорию, задавайте вопросы в чате. Я подскажу, пришлю примеры.' },
    { type: 'text', text: '"Вот похоже я так напрягаюсь, от внимания, что прям устала от четырех набросков." – вот здесь хочется разобраться. Подходит ли вам такая усталость. Если это некомфортно, так не нравится, с этим стоит поработать. Сейчас у вас подробные, детализированные работы. А что если ограничить рисунок 10 линиями? А что если рисовать строго за 1 минуту? Или любое другое ограничение, которое просто не даст возможности углубиться в детали и похожесть.' },
    { type: 'text', text: 'Можно попробовать порисовать "законные, трушные каракули". Например, как у Лены Новоселовой.' },
    {
      type: 'image',
      imageData: {
        id: 'ElenaNovoselova1.jpeg',
        alt: 'ElenaNovoselova1',
        caption: [
          {
            tag: 'a',
            content: 'Elena Novoselova',
            props: { className: 's-hoverable', target: "_blank", to: 'https://www.instagram.com/novoelena/' },
          },
        ],
      },
    },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно залогиниться под любой почтой.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/31RgMQN19zdFPgEfgbCpbr/%D0%98%D1%80%D0%B8%D0%BD%D0%B0-%D0%94?type=design&node-id=1%3A8&mode=design&t=LD9x5XawrZaSNMv8-1' },
        },
      ]}

  ],
};

const review13: TReview = {
  homeworkId: 'how-to-draw-free_HowToDrawSimilarPictureLine_t6qrnq_Practice_iqln35_hw-xAjP5m8ZJHWvYPPH7AzR2hoLc1C2',
  review: [
    { type: 'text', text: 'Я в восторге от того, сколько вы нарисовали работ! Вы большая умничка)' },
    { type: 'text', text: '' },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно залогиниться под любой почтой.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/gk0H58IeWAnmP97afPTlS5/Wambanuka?type=design&node-id=0%3A1&mode=design&t=12FcIExJxfhxzxW7-1' },
        },
      ]}

  ],
};

const review21: TReview = {
  homeworkId: 'how-to-draw-free_SpotPractice_kfKAEY_hw-FhEwHm2rg4dqGzqMjiRhfFhgEIk1',
  review: [
    { type: 'text', text: 'Добрый день! У вас здорово получается экспериментировать с материалами. Все котики очень-очень хорошие.' },
    { type: 'text', text: '"слушала себя и рисовала как чувствовала" — очень рада, что у вас получилось переключиться на себя! Это правильный подход.' },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно скачать на телефон приложение Figma и залогиниться под любой почтой.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/M8SeWVu0YzLQgbX44Z8zMc/%D0%A1%D0%B2%D0%B5%D1%82%D0%BB%D0%B0%D0%BD%D0%B0-%D0%91%D0%BB%D0%BE%D0%BA?type=design&node-id=0%3A1&mode=design&t=6c9IgStQ2iqtBIBK-1' },
        },
      ]}

  ],
};

const review31: TReview = {
  homeworkId: 'how-to-draw-free_LineSpotPractice_L8A8Jk_hw-FhEwHm2rg4dqGzqMjiRhfFhgEIk1',
  review: [
    { type: 'text', text: 'Добрый день! Все котики отличные и формат — интересный.' },
    { type: 'text', text: '"Захотелось увидеть котиков в миниатюре, чтобы не было соблазна засидеться за рисованием одного кота на час, другой. Ну и не выбрасывать же работу если не удался один котик! Когда их много и они вместе - не так страшно выглядит неудачный штрих на ком-то одном, особенно если его можно прорисовать и сделать особенностью котика!" — да, все верно говорите. Когда котиков много, работа — это уже не отдельный котик. Работа — это то, как они смотрятся все вместе. И тут уже действительно не страшно как выглядит неудачный штрих на ком-то одном.' },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно скачать на телефон приложение Figma и залогиниться под любой почтой.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/M8SeWVu0YzLQgbX44Z8zMc/%D0%A1%D0%B2%D0%B5%D1%82%D0%BB%D0%B0%D0%BD%D0%B0-%D0%91%D0%BB%D0%BE%D0%BA?type=design&node-id=0%3A1&mode=design&t=6c9IgStQ2iqtBIBK-1' },
        },
      ]}

  ],
};

const review32: TReview = {
  homeworkId: 'how-to-draw-free_LineSpotPractice_L8A8Jk_hw-xAjP5m8ZJHWvYPPH7AzR2hoLc1C2',
  review: [
    { type: 'text', text: 'Добрый день! Лихое пятно отлично сработало! Собачки все очень живые и динамичные.' },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно скачать на телефон приложение Figma и залогиниться под любой почтой.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/gk0H58IeWAnmP97afPTlS5/Wambanuka?type=design&node-id=0%3A1&mode=design&t=12FcIExJxfhxzxW7-1' },
        },
      ]}

  ],
};

const reviewFYS1: TReview = {
  homeworkId: 'finding-your-style_FindingYourStyle_Practice_ t4jUts_hw-CegUWy9jv9Y0bzk7utsz4eJGe8O2',
  review: [
    { type: 'text', text: 'Алина, добрый день! У вас красивые и добрые работы.' },
    { type: 'text', text: 'Нравится медленный и нюансный ход развития событий. Он гармонирует с общей атмосферой рисунков.' },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно залогиниться под любой почтой в Figma, с ноута это можно сделать в любом браузере, с телефона вначале нужно скачать приложение Figma и установить его.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/UxufYpIgUNHxY3A3KN0FrX/Alina?type=design&node-id=0%3A1&mode=design&t=YR1yWIYBTQcurMQ7-1' },
        },
      ]}

  ],
};

const reviewFYS2: TReview = {
  homeworkId: 'finding-your-style_FindingYourStyle_Practice_ t4jUts_hw-FT6xck55rfWedWZoGNweBluhq7s1',
  review: [
    { type: 'text', text: 'Даша, добрый день! Ощущение тесной, подводной пещеры чувствуется. Оно складывается из темного фона, закрытости/запертости светлого пятна внутри темной коробки. И обратите внимание, в работах очень легкий фигуратив. Чтобы добиться нужного ощущения даже не пришлось рисовать пещеру. Все хорошо сработало только за счет расположения масс.' },
    { type: 'text', text: '“Еще не совсем уверена насчет выбора материала. Я брала черный соус и чернографитный карандаш, потом добавляла цвет в цифре, но, возможно, можно было бы сделать голубую подложку красками или цветными карандашами, чтобы была текстура, либо просто сделать текстуру камней более выраженной, но не знаю, насколько это нужно вообще.” — мне, как зрителю, нравится выбранная вами техника! Я бы ее не меняла.' },
    { type: 'text', text: 'Чтобы усилить ощущение тесноты, можно еще сильнее сократить количество черного.' },
    { type: 'text', text: 'Чтобы рисунок было интереснее рассматривать — можно выборочно добавить более четкую прорисовку. Так мы сможем точечно привлекать внимание зрителя к важным местам в рисунке. Например, к положению головы и рук.' },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно залогиниться под любой почтой в Figma, с ноута это можно сделать в любом браузере, с телефона вначале нужно скачать приложение Figma и установить его.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/kq0ZEBD9gu757C5BRGiH0e/Blue-Chainik?type=design&node-id=0%3A1&mode=design&t=brfqBpoPh9H5sp9k-1' },
        },
      ]}

  ],
};

const reviewFYS3: TReview = {
  homeworkId: 'finding-your-style_FindingYourStyle_Practice_ t4jUts_hw-e0hqTpnEIeRRlK85YRxtcVGIIgA2',
  review: [
    { type: 'text', text: 'Анастасия, добрый день! Сюжеты просто волшебные, очень нравится ваша идея для серии!)' },
    { type: 'text', text: 'Пластика изображения хорошо сработала. Серия читается, как серия. Основные моменты рисунка раскрываются за счет контрастов, противопоставлении линий и пятен.' },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно залогиниться под любой почтой в Figma, с ноута это можно сделать в любом браузере, с телефона вначале нужно скачать приложение Figma и установить его.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/Ved8iFf8VIq1THOf4lQ38a/Ana-Ana?type=design&node-id=0%3A1&mode=design&t=t1FPPaxhAVRlbdG5-1' },
        },
      ]}

  ],
};

const reviewFYS4: TReview = {
  homeworkId: 'finding-your-style_FindingYourStyle_Practice_ t4jUts_hw-xAjP5m8ZJHWvYPPH7AzR2hoLc1C2',
  review: [
    { type: 'text', text: 'Юлия, добрый день! Глубокая идея для серии, вызывает эмоции, сразу появляется сопережевание главному герою — чайке.' },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно залогиниться под любой почтой в Figma, с ноута это можно сделать в любом браузере, с телефона вначале нужно скачать приложение Figma и установить его.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/bNmB5Ti1ezr3sH5k8tdx2W/Wambanuka?type=design&node-id=0%3A1&mode=design&t=Lq7jhxJP6euccA4R-1' },
        },
      ]}

  ],
};

const reviewFYS5: TReview = {
  homeworkId: 'finding-your-style_FindingYourStyle_Practice_ t4jUts_hw-xcN3gBQ6GIPi4Nlfr56W3Toj3pf1',
  review: [
    { type: 'text', text: 'Елена, добрый день! Общая идея действительно понятна. И это хороший заход для серии. Здесь много направлений, с которыми интересно работать.' },
    { type: 'text', text: 'По ссылке ниже холст с вашими рисунками и моими комментариями. Чтобы отвечать на комменты, вести диалог, нужно залогиниться под любой почтой в Figma, с ноута это можно сделать в любом браузере, с телефона вначале нужно скачать приложение Figma и установить его.' },
    { type: 'text',
      text: [
        {
          tag: 'a',
          content: 'Комментарии к рисункам в Figma',
          props: { className: 'link', target: "_blank", to: 'https://www.figma.com/file/DIqT2X5DbjYjlnGAeyw6IB/Tsurikova-Elena?type=design&node-id=0%3A1&mode=design&t=AnCQjP2K27lknBsz-1' },
        },
      ]}

  ],
};

const allReviews = [
  review11,
  review12,
  review13,
  review21,
  review31,
  review32,
  reviewFYS1,
  reviewFYS2,
  reviewFYS3,
  reviewFYS4,
  reviewFYS5,
];

export function getReview(filter: { homeworkId: string }) {
  return allReviews.find(({ homeworkId }) => homeworkId === filter.homeworkId)?.review;
}
